import { render, staticRenderFns } from "./ProfileShareModal.vue?vue&type=template&id=37c195db&"
import script from "./ProfileShareModal.vue?vue&type=script&lang=js&"
export * from "./ProfileShareModal.vue?vue&type=script&lang=js&"
import style0 from "./ProfileShareModal.vue?vue&type=style&index=0&id=37c195db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports